export default "__VITE_ASSET__B7AHPaYj__$_?url__"